<template>
  <footer class="footer" :class="[footer === 'footer-dark' ? 'footer-dark' : '', { 'close_icon': !togglesidebar, 'mini-sidebar': miniSidebar }]">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 footer-copyright text-center">
          <p class="mb-0">Copyright &copy; 2024. All Rights Reserved. Developed by LAUGFS Group IT</p>
          <p>Version: {{ version }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getVersion } from '@/services/versionService'

export default {
  name: 'footerpage',
  data() {
    return {
      customizer: false,
      version: ''
    };
  },
  computed: {
    ...mapGetters({
      footer: 'layout/footer'
    }),
    ...mapState({
      togglesidebar: (state) => state.menu.togglesidebar,
      miniSidebar: (state) => state.menu.miniSidebar
    })
  },
  async mounted() {
    this.version = await getVersion();
  }
};
</script>

<style scoped>
.footer {
  padding-top: 10px;
  margin-bottom: -10px;
  transition: all 0.3s ease;
}

.footer.close_icon, .footer.mini-sidebar {
  margin-left: 0 !important;
}

</style>